import {type FC, memo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props as ModalProps} from '@src/components/ModalNew';

import Modal from '@src/components/ModalNew';

import type {Props as PrivateDataRequestProps} from './PrivateDataRequest';

import PrivateDataRequest from './PrivateDataRequest';

type Props = Partial<ModalProps> & PrivateDataRequestProps;

const PrivateDataRequestModal: FC<Props> = ({
  children,
  onSet,
  privateDataRequest,
  ...modalProps
}) => {
  const {t} = useI18n();

  return (
    <Modal
      {...modalProps}
      title={t('shared:CRUProgramPrivateDataRequest.title')}
    >
      <PrivateDataRequest
        onSet={onSet}
        privateDataRequest={privateDataRequest}
      />
      {children}
    </Modal>
  );
};

export default memo(PrivateDataRequestModal);
